import { ProductType } from 'shared/products/domain/productType';
import type { Unit } from '../../common/domain/bulkUnits';

export interface Product {
  id: string;
  name: string;
  description: string;
  type: ProductType;
  color: string | null;
  quality: string | null;
  logData: LogData | null;
  externalCode: string | null;
  coilData: CoilData | null;
  bulkData: BulkData | null;
  dimensionData: DimensionData | null;
  productGroupId: string | null;
}

export interface LogData {
  logsPerSquareMeter: number;
  minDiameter: number | null;
  maxDiameter: number | null;
  maxLength: number | null;
  minLength: number | null;
  averageCylinderVolume: number | null;
  averagePhysicalVolume: number | null;
  isSorted: boolean;
  species: string | null;
  logSorterName: string | null;
  sawLineName: string | null;
}

export interface CoilData {
  diameter: number|null;
  depth: number|null;
}

export interface BulkData {
  unit: Unit;
  density: number;
}

export interface DimensionData {
  nominalDensity: number | null;
  density: number | null;
  nominalThickness: number | null;
  thickness: number | null;
  nominalWidth: number | null;
  width: number | null;
  nominalLength: number | null;
  length: number | null;
  moisture: number | null;
}

export function createProduct(id: string): Product {
  return {
    id: id,
    name: '',
    description: '',
    color: null,
    quality: null,
    type: ProductType.Undefined,
    logData: null,
    coilData: null,
    bulkData: null,
    dimensionData: null,
    externalCode: null,
    productGroupId: null
  };
}

export function estimateVolume(product: Product, numberOfLogs: number) {
  const logData = product.logData;
  if (!logData) return 0;

  const logYardAveragePhysicalVolume = logData.averagePhysicalVolume;
  if (logYardAveragePhysicalVolume === null) return 0;

  return logYardAveragePhysicalVolume * numberOfLogs;
}
